"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LockOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M25,14H23V8a6,6,0,0,0-6-6H15A6,6,0,0,0,9,8v6H7a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V16A2,2,0,0,0,25,14ZM11,8a4,4,0,0,1,4-4h2a4,4,0,0,1,4,4v6H11ZM25,28H7V16H25Z"/><path d="M17,22.28V19a1,1,0,0,0-2,0v3.28A2,2,0,0,0,14,24a2,2,0,0,0,4,0A2,2,0,0,0,17,22.28Z"/>';
var LockOutlineSVG = function LockOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LockOutlineSVG = LockOutlineSVG;
LockOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LockOutlineSVG);
exports.default = _default;